import React from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logoFull from '../assets/logo.png';
import logoIcon from '../assets/icon.png';
import '../App.css';

const Icon: React.FC<{ children: string }> = ({ children }) => (
  <span className="icon">{children}</span>
);

const AdminLayout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isMini = location.pathname === '/admin/statistiques';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <aside className={`sidebar ${isMini ? 'mini' : ''}`}>
        <div className="sidebar-header">
          {isMini ? (
            <img src={logoIcon} alt="FORGEST" style={{ width: 36, height: 36 }} />
          ) : (
            <img src={logoFull} alt="FORGEST" style={{ width: 180 }} />
          )}
        </div>

        {user && !isMini && (
          <div style={{ padding: '12px 20px', borderBottom: '1px solid rgba(255,255,255,0.15)', fontSize: 13 }}>
            <div style={{ fontWeight: 600 }}>{user.prenom} {user.nom}</div>
            <div style={{ opacity: 0.7, fontSize: 11 }}>{user.role}</div>
          </div>
        )}

        <div className="sidebar-section">
          <NavLink to="/admin" end className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Tableau de bord">
            <Icon>&#9776;</Icon> <span>Tableau de bord</span>
          </NavLink>
        </div>

        <div className="sidebar-section">
          <div className="sidebar-section-title">Exploitation</div>
          <NavLink to="/admin/partenaires" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Partenaires">
            <Icon>&#127760;</Icon> <span>Partenaires</span>
          </NavLink>
          <NavLink to="/admin/forages" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Forages">
            <Icon>&#128167;</Icon> <span>Forages</span>
          </NavLink>
          <NavLink to="/admin/secteurs" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Secteurs">
            <Icon>&#128205;</Icon> <span>Secteurs</span>
          </NavLink>
          <NavLink to="/admin/localites" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Localités">
            <Icon>&#128204;</Icon> <span>Localités</span>
          </NavLink>
          <NavLink to="/admin/abonnes" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Abonnés">
            <Icon>&#128101;</Icon> <span>Abonnés</span>
          </NavLink>
          <NavLink to="/admin/productions" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Productions">
            <Icon>&#9881;</Icon> <span>Productions</span>
          </NavLink>
          <NavLink to="/admin/sms-broadcast" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="SMS Promotionnels">
            <Icon>&#128172;</Icon> <span>SMS Promotionnels</span>
          </NavLink>
        </div>

        <div className="sidebar-section">
          <div className="sidebar-section-title">Finances</div>
          <NavLink to="/admin/factures" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Factures">
            <Icon>&#128196;</Icon> <span>Factures</span>
          </NavLink>
          <NavLink to="/admin/paiements" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Paiements">
            <Icon>&#128176;</Icon> <span>Paiements</span>
          </NavLink>
          <NavLink to="/admin/mobile-payments" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Mobile Money">
            <Icon>&#128241;</Icon> <span>Mobile Money</span>
          </NavLink>
          <NavLink to="/admin/charges" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Charges">
            <Icon>&#128181;</Icon> <span>Charges</span>
          </NavLink>
          <NavLink to="/admin/comptabilite" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Comptabilité">
            <Icon>&#128202;</Icon> <span>Comptabilité</span>
          </NavLink>
        </div>

        <div className="sidebar-section">
          <div className="sidebar-section-title">Analyses</div>
          <NavLink to="/admin/statistiques" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Statistiques">
            <Icon>&#128200;</Icon> <span>Statistiques</span>
          </NavLink>
          <NavLink to="/admin/cartographie" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Cartographie">
            <Icon>&#127758;</Icon> <span>Cartographie</span>
          </NavLink>
          <NavLink to="/admin/analytics" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Analytics">
            <Icon>&#129504;</Icon> <span>Analytics</span>
          </NavLink>
        </div>

        <div className="sidebar-section">
          <div className="sidebar-section-title">Administration</div>
          <NavLink to="/admin/users" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Utilisateurs">
            <Icon>&#128100;</Icon> <span>Utilisateurs</span>
          </NavLink>
          <NavLink to="/admin/tracking" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Tracking">
            <Icon>&#128270;</Icon> <span>Tracking</span>
          </NavLink>
          <NavLink to="/admin/agent-positions" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} title="Positions agents">
            <Icon>&#128205;</Icon> <span>Positions agents</span>
          </NavLink>
        </div>

        <div style={{ marginTop: 'auto', padding: '10px 0', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
          <NavLink to="/" className="sidebar-link" title="Site vitrine">
            <Icon>&#127968;</Icon> <span>Site vitrine</span>
          </NavLink>
          <button onClick={handleLogout} className="sidebar-link" title="Deconnexion" style={{ width: '100%', border: 'none', background: 'none', color: '#fff', cursor: 'pointer', textAlign: 'left', font: 'inherit' }}>
            <Icon>&#128682;</Icon> <span>Deconnexion</span>
          </button>
        </div>
      </aside>

      <div className={`main-content ${isMini ? 'mini' : ''}`}>
        <div className="top-bar">
          <h1>Administration</h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
            <span style={{ color: '#999', fontSize: '14px' }}>
              {user ? `${user.prenom} ${user.nom}` : 'FORGEST Globale'}
            </span>
            <button onClick={handleLogout} style={{
              background: '#f44336', color: '#fff', border: 'none', padding: '6px 16px',
              borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600
            }}>
              Deconnexion
            </button>
          </div>
        </div>
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
